import React from 'react';
import SectionHeading from '../../SectionHeading';
import Spacing from '../../Spacing';

export default function ImageDescriptionSection({
  imgUrl,
  spiningImgUrl,
  title,
  subTitle,
  description,
}) {
  return (
    <section className="cs_style_1">
      <div className="container">
        <SectionHeading title={title} center />
        <Spacing md="20" lg="20" sm="20" />
        <h3 className="cs_section_subtitle text-uppercase text-center cs_accent_color cs_semibold m-0 cs_accent_color cs_fs_32">
                  {subTitle}
                </h3>
        <div className="row align-items-center flex-lg-row flex-column-reverse cs_gap_y_40">
          <div className="col-lg-7">
            <div className="cs_about_content">
              <Spacing md="72" lg="72" sm="30" />
              {description?.map((item, index) => (
                <React.Fragment key={index}>
                  {index > 0 && <Spacing md="40" lg="60" sm="30" />}
                  <p className="m-0 text-justify">{item}</p>
                </React.Fragment>
              ))}
            </div>
          </div>
          <div className="col-lg-5">
            <Spacing md="55" />
            <div className="cs_about_img">
              <img src={imgUrl} alt="Explore" />
              {/* <div className="cs_about_mini_img">
                <img
                  src="/images/icons/tick.svg"
                  alt="Right"
                  className="cs_right_icon"
                />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
